/* eslint-disable camelcase */
import React, { useRef } from 'react'
import uuid from 'uuid/v1'

import DealCard from '../deal-card'
import { ModalTrigger } from '../modal'
import { useEcommerceContext } from '~/contexts/ecommerce-context'
import { usePageContext } from '~/contexts/page-context'
import { useClickoutUrl } from '~/hooks/useClickoutUrl'
import { trackDealClick, getSegmentProps, clickAnchor } from '~/utils/tracking'

const Deal = ({
  deal,
  tenancy = {},
  isSponsored = false,
  ecommerce,
  position,
  list,
  placementType,
  adType,
  kevelClickUrl,
  criticalJs,
  hasUspAnimated,
  setHasUspAnimated,
  cityFibreDealsAvailable
}) => {
  const { pageId } = usePageContext()

  const dealLinkRef = useRef(null)

  const {
    data: { comparisonId }
  } = useEcommerceContext()

  const clickoutLinkUrl = useClickoutUrl({
    deal,
    position,
    list,
    placementType
  })

  const segmentProps = getSegmentProps({
    pageId,
    deal,
    comparisonId,
    position,
    dealUrl: clickoutLinkUrl,
    adType,
    placementType
  })

  const handleOnClick = (e) => {
    e.stopPropagation()

    if (e.target.tagName.toLowerCase() !== 'a') return clickAnchor(e, dealLinkRef)

    const eventLabelSuffix = e.target.getAttribute('data-is-more-info') === 'true' ? ' more info' : ''

    trackDealClick({ segmentProps, adType, ecommerce, kevelClickUrl, tenancy, eventLabelSuffix })
  }

  return (
    <ModalTrigger
      id='deal'
      data-trigger-source-param='dealCardModal'
      data-trigger-source-id-param={uuid()}
      data-trigger-clickout-param
      condition={criticalJs}
    >
      <DealCard
        deal={deal}
        tenancy={tenancy}
        list={list}
        position={position}
        adType={adType}
        placementType={placementType}
        href={clickoutLinkUrl}
        onClick={handleOnClick}
        isSponsored={isSponsored}
        hasUspAnimated={hasUspAnimated}
        setHasUspAnimated={setHasUspAnimated}
        criticalJs={criticalJs}
        segmentProps={segmentProps}
        dealLinkRef={dealLinkRef}
        cityFibreDealsAvailable={cityFibreDealsAvailable}
      />
    </ModalTrigger>
  )
}

export default Deal
